export default __webpack_public_path__ + "static/media/SEC1920.34I-40943_-24264_0.bec74f90.jpg";